(function() {
    'use strict';

    angular.module('remitEventsApp').factory('translationStorageProvider', function($cookies, LANGUAGES) {
        function get(name) {
            var language = $cookies.get(name);
            language = language ? language.replace(/"/g, '') : 'pl';

            if (LANGUAGES.indexOf($cookies.get(name)) === -1) {
                $cookies.putObject(name, 'pl');
            }
            return language;
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }

        return {
            get: get,
            put: put
        };
    });
})();
